import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	estimationUpdated: {
		id: 'software-burnup-report.chart.tooltip.get-tooltip-text.estimation-updated',
		defaultMessage: 'Estimate updated',
		description: 'Tooltip message for estimation changes',
	},
	transitionToDone: {
		id: 'software-burnup-report.chart.tooltip.get-tooltip-text.transition-to-done',
		defaultMessage: 'Transition to done',
		description: 'Tooltip message for issue completed',
	},
	transitionToNotDone: {
		id: 'software-burnup-report.chart.tooltip.get-tooltip-text.transition-to-not-done',
		defaultMessage: 'Transition to not done',
		description: 'Tooltip message for issue not done',
	},
	issueRemoved: {
		id: 'software-burnup-report.chart.tooltip.get-tooltip-text.issue-removed',
		defaultMessage: 'Issue removed from sprint',
		description: 'Tooltip message for issue removed from sprint',
	},
	issueAdded: {
		id: 'software-burnup-report.chart.tooltip.get-tooltip-text.issue-added',
		defaultMessage: 'Issue added to sprint',
		description: 'Tooltip message for issue added to sprint',
	},
});

export default messages;
